import { Router } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import EventBus from "services/eventBus";
import SecurityService from "services/securityService";
import { computed } from "mobx";
import NotificationService from "services/notificationService";
import OptionsService from "services/optionsService";
import BankExportRepository from "repositories/bankExportRepository";
import BankTransferDetailViewModel from "./bankTransferDetailViewModel";
import download from "downloadjs";
import BankExportListViewModel from "../bankExportListViewModel";
import { getBankExportFilename } from "../utils";
import parseFileNameFromAxiosResponse from "utils/parseFileNameFromAxiosResponse";
import type TransferType from "entities/transferType";
import type TransferRefundExportResponse from "entities/transferRefundExportResponse";

const navigationName = "bank-transfers";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [BankTransferDetailViewModel],
})
export default class BankTransferListViewModel extends BankExportListViewModel<TransferRefundExportResponse> {
  @computed
  get name() {
    return this.translate("bankTransfers");
  }

  constructor(
    public detailViewModelFactory: ReturnType<typeof BankTransferDetailViewModel.Factory>,
    public repository: BankExportRepository,
    public securityService: SecurityService,
    public eventBus: EventBus,
    public localizationService: LocalizationService,
    public notificationService: NotificationService,
    public optionsService: OptionsService
  ) {
    super(repository, securityService, eventBus, localizationService, notificationService, optionsService);
    this.navigationName = navigationName;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.allBankTransfers({ offset, limit }, this.appliedFilter);
  }

  async download(item: TransferRefundExportResponse) {
    try {
      if (this.allowToDownload) {
        this.fileResponse = await this.repository.getBankTransferReport(item.id);
        download(
          this.fileResponse.data,
          parseFileNameFromAxiosResponse(this.fileResponse, getBankExportFilename(item)),
          "application/zip"
        );
      }
    } catch (exc) {}
  }

  translateState(state: TransferType) {
    return this.localizationService.translateEnum("transferType", state);
  }
}
